module.exports = {"audiences":["alphaMembers","superHomeMembers","allMembers"],"experimentAllocation":{"allMembers":0,"alphaMembers":1,"superHomeMembers":1},"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/superHome.json
// module id = z7ax
// module chunks = 2